var render = function render(){var _vm=this,_c=_vm._self._c;return _c('themed-card',[_c('v-card-text',[_vm._v("\n        This product has been reported as stolen\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }